import { apiSlice } from '../../app/api/apiSlice';

export const pricingApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get all pricing data
    getPricing: builder.query({
      query: (params = {}) => ({
        url: '/pricing',
        params
      }),
      providesTags: ['Pricing']
    }),

    // Get pricing by category
    getPricingByCategory: builder.query({
      query: ({ category, region }) => ({
        url: `/pricing/category/${category}`,
        params: { region }
      }),
      providesTags: ['Pricing']
    }),

    // Get pricing for AI context
    getPricingForAI: builder.query({
      query: () => '/pricing/ai',
      providesTags: ['Pricing']
    }),

    // Get single pricing item
    getPricingById: builder.query({
      query: (id) => `/pricing/${id}`,
      providesTags: ['Pricing']
    }),

    // Get pricing statistics
    getPricingStats: builder.query({
      query: () => '/pricing/stats',
      providesTags: ['PricingStats']
    }),

    // Create pricing item
    createPricing: builder.mutation({
      query: (pricingData) => ({
        url: '/pricing',
        method: 'POST',
        body: pricingData
      }),
      invalidatesTags: ['Pricing', 'PricingStats']
    }),

    // Update pricing item
    updatePricing: builder.mutation({
      query: ({ id, ...pricingData }) => ({
        url: `/pricing/${id}`,
        method: 'PUT',
        body: pricingData
      }),
      invalidatesTags: ['Pricing', 'PricingStats']
    }),

    // Delete pricing item
    deletePricing: builder.mutation({
      query: (id) => ({
        url: `/pricing/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Pricing', 'PricingStats']
    }),

    // Bulk update pricing
    bulkUpdatePricing: builder.mutation({
      query: (updates) => ({
        url: '/pricing/bulk',
        method: 'PUT',
        body: updates
      }),
      invalidatesTags: ['Pricing', 'PricingStats']
    }),

    // Toggle pricing status
    togglePricingStatus: builder.mutation({
      query: (id) => ({
        url: `/pricing/toggle-status/${id}`,
        method: 'PUT'
      }),
      invalidatesTags: ['Pricing', 'PricingStats']
    })
  })
});

export const {
  useGetPricingQuery,
  useGetPricingByCategoryQuery,
  useGetPricingForAIQuery,
  useGetPricingByIdQuery,
  useGetPricingStatsQuery,
  useCreatePricingMutation,
  useUpdatePricingMutation,
  useDeletePricingMutation,
  useBulkUpdatePricingMutation,
  useTogglePricingStatusMutation
} = pricingApiSlice;
